import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class FieldSelect extends BasicEntity {
code: string;
exclude: boolean | null;
include: boolean | null;
}

